import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { Station } from "./model/station";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const routes = {
  quote: (c: NearStationsContext) =>
    `/iPlaceCloud/api/v1/ranking?iPlaceId=${c.iPlaceId}&radius=${c.radius}&timemilis=${c.timemilis}`
};

export interface NearStationsContext {
  // The quote's category: 'dev', 'explicit'...
  iPlaceId: string;
  radius: number;
  timemilis: number;

}

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

@Injectable()
export class PetrolRankingService {
  private errorHandler(error: any): Promise<any> {
    console.log("An error occurred", error);
    return Promise.reject(error.message || error);
  }

  private basePath = "/iPlaceCloud/api/v1/ranking";

  constructor(private httpClient: HttpClient) { }

  getNearStations(context: NearStationsContext): Promise<any> {
    let url = this.basePath;
    return this.httpClient
      .get(routes.quote(context))
      .toPromise()
      .then(res => res as Station[])
      .catch(error => this.errorHandler(error));
  }

  // getNearStations(context: NearStationsContext): Observable<Station[]> {
  //   return this.httpClient.get<Station[]>(routes.quote(context));
  // }

  public exportAsExcelFile(
    headers: any[],
    stations: Station[],
    excelFileName: string
  ): void {
    var ws_data = [[]];

    headers.forEach(header => {
      ws_data[0].push(header.label);
    });

    for (let i = 0; i < stations.length; i++) {
      const station = stations[i];
      let stationInfo = [];
      headers.forEach(header => {
        stationInfo.push(station[header.property]);
      });
      ws_data.push(stationInfo);
    }

    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(ws_data);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"]
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(
      data,
      fileName + "_near_stations_prices" + EXCEL_EXTENSION
    );
  }
}
